/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Invalidregistrationcode2Inputs */

const en_errors_invalidregistrationcode2 = /** @type {(inputs: Errors_Invalidregistrationcode2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation is invalid or has already been claimed`)
};

/**
* | output |
* | --- |
* | "This invitation is invalid or has already been claimed" |
*
* @param {Errors_Invalidregistrationcode2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_invalidregistrationcode2 = /** @type {((inputs?: Errors_Invalidregistrationcode2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Invalidregistrationcode2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_invalidregistrationcode2(inputs)
});
export { errors_invalidregistrationcode2 as "errors_invalidRegistrationCode" }